import { render, staticRenderFns } from "./shipping-page.vue?vue&type=template&id=88b21474"
import script from "./shipping-page.vue?vue&type=script&lang=js"
export * from "./shipping-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88b21474')) {
      api.createRecord('88b21474', component.options)
    } else {
      api.reload('88b21474', component.options)
    }
    module.hot.accept("./shipping-page.vue?vue&type=template&id=88b21474", function () {
      api.rerender('88b21474', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CustomerViews/Shipping/shipping-page.vue"
export default component.exports